module.exports = __webpack_public_path__ + "img/15.4099926f.jpg";